import React, { useState, useEffect, useRef } from "react";

import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";
import levelModal from "models/level.modal";
import { Bar } from "react-chartjs-2";
import { Button, Col, Container, Input, Row, Table } from "reactstrap";
import ReportModel from "models/report.modal";

const Report = () => {
  const [datalist, setDatalist] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;
  const [chartData, setChartData] = useState(null);
  const[status,setStatus]=useState("");

  // New state for date filters
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Pagination logic
  const paginatedData = currentData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  const getChartData = (data) => ({
    labels: data.map((person) => `${person?.monthName}`),
    datasets: [
      {
        label: "Total Sale",
        data: data.map((person) => person?.classResult?.total_sales),
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
      {
        label: "Net Sale",
        data: data.map((person) => person?.classResult?.net_sales),
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
      },
      {
        label: "Tutor Salary",
        data: data.map((person) => person?.classResult?.tutor_salary),
        backgroundColor: "rgba(255, 206, 86, 0.2)",
        borderColor: "rgba(255, 206, 86, 1)",
        borderWidth: 1,
      },
    ],
  });

  const fetchData = async (fromDate, toDate) => {
    try {
      const response = await ReportModel.overcomelistbydate(fromDate, toDate);
      const fetchedData = response?.data || [];
      setDatalist(fetchedData);
      setCurrentData(fetchedData);
      setChartData(getChartData(fetchedData));
    } catch (error) {
      console.error("Error fetching report data:", error);
    }
  };

  // Fetch data when the component mounts
  useEffect(() => {
    const toDate = new Date();
    const fromDate = new Date();
    fromDate.setDate(toDate.getDate() - 30);
    fetchData(formatDate(fromDate), formatDate(toDate));
  }, []);

  // Update chart data when currentData changes
  useEffect(() => {
    if (currentData.length > 0) {
      setChartData(getChartData(currentData));
    }
  }, [currentData]);

  const handleFilter = async () => {
    try {
      const response = await ReportModel.overcomelistbydate(startDate, endDate);
      const fetchedData = response?.data || [];
      setStatus("")
      setDatalist(fetchedData);
      setCurrentData(fetchedData);
      setChartData(getChartData(fetchedData));
    } catch (error) {
      console.error("Error fetching report data:", error);
    }
  };
  const handleFilter7day = async () => {
    try {
      // Calculate today's date
      const endDate = new Date(); // Today
  
      // Calculate the date 6 days before today
      const startDate = new Date();
      startDate.setDate(endDate.getDate() - 6); // Subtract 6 days from today
  
      // Format dates to match API expectations (if needed)
      const formattedStartDate = startDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD
      const formattedEndDate = endDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  
      console.log("Start Date:", formattedStartDate);
      console.log("End Date:", formattedEndDate);
  
      // Fetch data
      const response = await ReportModel.overcomelistbydate(formattedStartDate, formattedEndDate);
      const fetchedData = response?.data || [];
      
      // Update state
      setDatalist(fetchedData);
      setCurrentData(fetchedData);
      setChartData(getChartData(fetchedData));
    } catch (error) {
      console.error("Error fetching report data:", error);
    }
  };
  const handleFilterCurrentMonth = async () => {
    try {
      // Get today's date
      const endDate = new Date();
  
      // Get the first day of the current month
      const startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
  
      // Format dates to match API expectations (if needed)
      const formattedStartDate = startDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD
      const formattedEndDate = endDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  
      console.log("Start Date (Month):", formattedStartDate);
      console.log("End Date (Month):", formattedEndDate);
  
      // Fetch data
      const response = await ReportModel.overcomelistbydate(formattedStartDate, formattedEndDate);
      const fetchedData = response?.data || [];
  
      // Update state
      setDatalist(fetchedData);
      setCurrentData(fetchedData);
      setChartData(getChartData(fetchedData));
    } catch (error) {
      console.error("Error fetching report data for the current month:", error);
    }
  };
  const handleFilterCurrentQuarter = async () => {
    try {
      // Get today's date
      const today = new Date();
      const currentYear = today.getFullYear();
  
      // Calculate the current quarter
      const currentMonth = today.getMonth() + 1; // JavaScript months are 0-based
      let startMonth;
      let endMonth;
  
      if (currentMonth <= 3) {
        // Q1: January to March
        startMonth = 0; // January
        endMonth = 2; // March
      } else if (currentMonth <= 6) {
        // Q2: April to June
        startMonth = 3; // April
        endMonth = 5; // June
      } else if (currentMonth <= 9) {
        // Q3: July to September
        startMonth = 6; // July
        endMonth = 8; // September
      } else {
        // Q4: October to December
        startMonth = 9; // October
        endMonth = 11; // December
      }
  
      // Start and end dates of the current quarter
      const startDate = new Date(currentYear, startMonth, 1); // First day of the quarter
      const endDate = new Date(currentYear, endMonth + 1, 0); // Last day of the quarter
  
      // Format dates to match API expectations
      const formattedStartDate = startDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD
      const formattedEndDate = endDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  
      console.log("Start Date (Quarter):", formattedStartDate);
      console.log("End Date (Quarter):", formattedEndDate);
  
      // Fetch data
      const response = await ReportModel.overcomelistbydate(formattedStartDate, formattedEndDate);
      const fetchedData = response?.data || [];
  
      // Update state
      setDatalist(fetchedData);
      setCurrentData(fetchedData);
      setChartData(getChartData(fetchedData));
    } catch (error) {
      console.error("Error fetching report data for the current quarter:", error);
    }
  };
  const handleFilterCurrentYear = async () => {
    try {
      // Get today's date
      const today = new Date();
      const currentYear = today.getFullYear();
  
      // Start and end dates for the current year
      const startDate = new Date(currentYear, 0, 1); // January 1st of the current year
      const endDate = new Date(currentYear, today.getMonth(), today.getDate()); // Today's date
  
      // Format dates to match API expectations
      const formattedStartDate = startDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD
      const formattedEndDate = endDate.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  
      console.log("Start Date (Year):", formattedStartDate);
      console.log("End Date (Year):", formattedEndDate);
  
      // Fetch data
      const response = await ReportModel.overcomelistbydate(formattedStartDate, formattedEndDate);
      const fetchedData = response?.data || [];
  
      // Update state
      setDatalist(fetchedData);
      setCurrentData(fetchedData);
      setChartData(getChartData(fetchedData));
    } catch (error) {
      console.error("Error fetching report data for the current year:", error);
    }
  };
  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleNext = () => {
    if ((currentPage + 1) * itemsPerPage < currentData.length) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const options = {
    scales: {
      y: { beginAtZero: true },
    },
  };

  // Function to format date to 'YYYY-MM-DD'
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return (
    <Container className="pt-7">
      <div
        style={{
          width: "90%",
          margin: "0 auto",
          padding: "20px",
          background: "#fff",
          borderRadius: "10px",
          boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Row className="pl-3 ">
          <Col xs={12} md={6}>
            <h2>Income Over Time</h2>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex align-items-center mb-2  " >
            <div className="" style={{display:"flex",width:"100%"}}>
              <div className=""style={{display:"flex",alignItems:"center",justifyContent:"space-between",width:"100%"}}>
                <div style={{display:"flex",justifyContent:"space-between",}}>
                
                  <span className={`d-flex text-${status == "day" ? "blue":"gray"} cursor-pointer btn`} onClick={()=>{
                    handleFilter7day();
                    setStatus("day")}}>Last 7 day</span>
                  <span className={`d-flex text-${status == "month" ? "blue":"gray"} cursor-pointer btn`} onClick={()=>{
                    handleFilterCurrentMonth();
                    setStatus("month")}}>Monthly</span>
                  <span className={`d-flex text-${status == "Quater" ? "blue":"gray"} cursor-pointer btn`} onClick={()=>{
                    handleFilterCurrentQuarter();
                    setStatus("Quater")}}>Quarterly </span>
                  <span className={`d-flex text-${status == "year" ? "blue":"gray"} cursor-pointer btn`}onClick={()=>{
                    handleFilterCurrentYear();
                    setStatus("year")}}>Yearly</span>
                </div>

                <div style={{display:"flex",justifyContent:"flex-end",alignItems:"center"}}>
                  <span className="mr-1 text-gray">From</span>
                  <Input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="From"
                  />
                </div>
                <div className="d-flex align-items-center mr-2">
                  <span className="mr-1 text-gray">To</span>
                  <Input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="To"
                  />
                </div>
                <Button onClick={handleFilter}>Filter</Button>
              </div>
            </div>
          </Col>
        </Row>
        <hr className="mt-0 mb-0" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          {chartData && <Bar data={chartData} options={options} />}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
            marginBottom: "20px",
          }}
        >
          <Button
            onClick={handlePrevious}
            disabled={currentPage === 0}
            outline
            color="primary"
          >
            Previous
          </Button>
          <Button
            onClick={handleNext}
            disabled={(currentPage + 1) * itemsPerPage >= currentData.length}
            outline
            color="primary"
          >
            Next
          </Button>
        </div>
        <div style={{ overflowX: "auto" }}>
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "10px",
                    textAlign: "left",
                  }}
                >
                  Month
                </th>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "10px",
                    textAlign: "left",
                  }}
                >
                  Total Sales
                </th>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "10px",
                    textAlign: "left",
                  }}
                >
                  Net Sales
                </th>
                <th
                  style={{
                    border: "1px solid black",
                    padding: "10px",
                    textAlign: "left",
                  }}
                >
                  Salary
                </th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((person, index) => (
                <tr key={index}>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {person?.monthName}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {person?.classResult?.total_sales}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {person?.classResult?.net_sales}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {person?.classResult?.tutor_salary}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </Container>
  );
};

export default Report;
